/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
    initialState: { currentUser?: API.CurrentUser, authorities: string[] } | undefined,
) {
    const {currentUser, authorities} = initialState ?? {};
    return {
        isOutSide: authorities?.includes('folder:formal') && !authorities?.includes('home'),
        canAdmin: currentUser && currentUser.access === 'admin' || false,
        //菜单
        canHome: authorities?.includes("home") || false,
        canProject: authorities?.includes("project") || false,
        canProjectProject: authorities?.includes("project:project") || false,
        canProjectMyProject: authorities?.includes("project:myproject") || false,
        canProjectCenter: authorities?.includes("project:center") || false,
        canTemplate: authorities?.includes("template") || false,
        canFolder: authorities?.includes("folder") || false,
        canFolderTmp: authorities?.includes("folder:tmp") || false,
        canFolderFormal: authorities?.includes("folder:formal") || false,
        canApprove: authorities?.includes("approve") || false,
        canApproveFlow: authorities?.includes("approve:flow") || false,
        canApproveRecord: authorities?.includes("approve:record") || false,
        canQuestion: authorities?.includes("question") || false,
        canReport: authorities?.includes("report") || false,
        canSystem: authorities?.includes("system") || false,
        canSystemPosition: authorities?.includes("system:position") || false,
        canSystemData: authorities?.includes("system:data") || false,
        canSystemCountry: authorities?.includes("system:country") || false,
        canSystemPlaceholder:
            authorities?.includes("system:placeholder") || false,

        canSystemDirectory:
            authorities?.includes("system:directoryperm") || false,
        // 按钮
        canProjectExport: authorities?.includes("project:export") || false,
        canProjectAdd: authorities?.includes("project:add") || false,
        canProjectEdit: authorities?.includes("project:edit") || false,
        canProjectInit: authorities?.includes("project:init") || false,
        canProjectAllocate: authorities?.includes("project:allocate") || false,
        canMyProjectExport: authorities?.includes("myproject:export") || false,
        canMyProjectAdd: authorities?.includes("myproject:add") || false,
        canMyProjectEdit: authorities?.includes("myproject:edit") || false,
        canMyProjectInit: authorities?.includes("myproject:init") || false,
        canMyProjectAllocate: authorities?.includes("myproject:allocate") || false,
        canCenterAdd: authorities?.includes("center:add") || false,
        canCenterEnable:
            authorities?.includes("center:enable:disable") || false,
        canCenterQuote: authorities?.includes("center:quote") || false,
        canTemplateImport: authorities?.includes("template:import") || false,
        canTemplateView: authorities?.includes("template:view") || false,
        canTemplateEdit: authorities?.includes("template:edit") || false,
        canTemplatePublish: authorities?.includes("template:release") || false,
        canTemplateDelete: authorities?.includes("template:delete") || false,
        canApproveAdd: authorities?.includes("flow:add") || false,
        canApproveEnable: authorities?.includes("flow:enable") || false,
        canApproveRecordView: authorities?.includes("record:view") || false,
        canPositionEdit: authorities?.includes("position:edit") || false,
        canPositionUser:
            authorities?.includes("position:related:users") || false,
        canPlaceholderAdd: authorities?.includes("placeholder:add") || false,
        canPlaceholderBatchActive:
            authorities?.includes("placeholder:activate:batch") || false,
        canPlaceholderEdit: authorities?.includes("placeholder:edit") || false,
        canPlaceholderCopy: authorities?.includes("placeholder:copy") || false,
        canPlaceholderActive:
            authorities?.includes("placeholder:activate:cancel") || false,
        canDataAdd: authorities?.includes("data:add") || false,
        canDataEdit: authorities?.includes("data:edit") || false,
        canDataDelete: authorities?.includes("data:delete") || false,
        canReportDownloadAll: authorities?.includes("report:download:all") || false,
        canSystemRegion: authorities?.includes("system:region") || false,
    };
}
